import React, { useContext } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { AccountHome } from "./pages/AccountHome/AccountHome";
import { AppLayout } from "./AppLayout";
import { HomePage } from "./pages/AppDashboard/AppDashboard";
import { LandingPage } from "./pages/LandingPage/LandingPage";
import { PaymentSuccessPage } from "./pages/PaymentSuccessPage/PaymentSuccessPage";
import { TermsOfUse } from "./pages/Terms/TermsOfUse";

// Context
import { AppContext } from "./context/appContext";
import { GenerativeSearch } from "./pages/GenerativeSearch/GenerativeSearch";

const createRouter = (isAuthenticated) =>
  createBrowserRouter([
    {
      path: "/*",
      element: <AppLayout />,
      children: [
        { path: "account", element: <AccountHome /> },
        { path: "payment-success", element: <PaymentSuccessPage /> },
        { path: "terms", element: <TermsOfUse /> },
        { path: "generative-search", element: <GenerativeSearch /> },
        {
          path: "*",
          element: isAuthenticated ? <HomePage /> : <LandingPage />,
        },
      ],
    },
  ]);

export const AppRoutes = ({ auth }) => {
  const { isAuthenticated } = useContext(AppContext);
  return <RouterProvider router={createRouter(isAuthenticated)} />;
};
